import { render, staticRenderFns } from "./IframeCom.vue?vue&type=template&id=58eaeaa4&scoped=true"
import script from "./IframeCom.vue?vue&type=script&lang=js"
export * from "./IframeCom.vue?vue&type=script&lang=js"
import style0 from "./IframeCom.vue?vue&type=style&index=0&id=58eaeaa4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58eaeaa4",
  null
  
)

export default component.exports